import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import { SimTypography } from 'components/SimTypography';
import SimFeaturedEventsSlider from 'components/SimFeaturedEventsSlider';
import SimSectionTitle from 'components/SimSectionTitle';

const FeaturedCommunitySessions = () => {
	const theme = useTheme();

	return (
		<Box>
			<Box marginBottom={4}>
				<SimSectionTitle
					title='Featured Community Sessions'
					subtitle='It takes a family to raise a child and it takes a village to raise a child with special needs'
					gutterBottom={false}
				/>
				<br />

				<SimTypography align={'left'} color={'text.secondary'} data-aos={'fade-up'}>
					Research shows that children make better progress when families are strongly engaged and involved.
					The diagnosis of developmental disorder is overwhelming but talking to parents really helps.
				</SimTypography>
				<br />

				<SimTypography align={'left'} color={'text.secondary'} data-aos={'fade-up'}>
					<Box component='span' color={theme.palette.primary.main}>
						Join our free community sessions, workshops and events{' '}
					</Box>{' '}
					to connect with fellow parents to learn quintesssential skills to raise children with special needs,
					and to help children learn social skills in a safe and naturalistic environment.
				</SimTypography>
			</Box>

			<SimFeaturedEventsSlider />
		</Box>
	);
};

export { FeaturedCommunitySessions };
